/**
 * Loads a Google Font on demand by injecting a <link> tag — used only when a
 * business has explicitly picked a curated display font (see
 * BusinessBrandingDefs). Never loaded globally, so pages for businesses that
 * haven't opted in pay zero extra cost. Injected once per font param per
 * session (module-level cache).
 */
const loadedFonts = new Set<string>();

export function ensureGoogleFont(googleFontParam: string | undefined): void {
  if (!googleFontParam || loadedFonts.has(googleFontParam)) return;
  loadedFonts.add(googleFontParam);
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${googleFontParam}&display=swap`;
  document.head.appendChild(link);
}
